
import MerchSliderDesktop from "@/merchandising/merchandising"
  


export default async () => {
      // merchandising

  const merchSection = document.querySelector("section.tf-merchandising");
  if (merchSection && window.seasonManager.isSummer()) { // TEMPORARY - disable and remove merch for summer until a solution is found
    // console.log(`hiding merch on summer`)
    merchSection.classList.add("d-none")
    // merchSection.remove() // TODO change to display none
  }
  else if (merchSection && !window.seasonManager.isSummer()) {
    merchSection.classList.remove("d-none")
  }

  if (window.screenSizeManager.screenType!=='mobile') {
    window.merchSliders = []

    Array.from(document.querySelectorAll('.merchandising-slider-desktop-wrapper')).forEach((sliderRoot) => {
      const slider = new MerchSliderDesktop(sliderRoot)
      slider.init()
      window.merchSliders.push(slider)
    })
  }
}